module.exports = __webpack_public_path__ + "img/poster-qrc.4f3cb058.jpg";